import styled from '@emotion/styled';
import { css } from '@emotion/react';

const StyledIconList = styled('ul')((props) => {
    const {
        theme: { mq, spacing }
    } = props;

    return css`
        list-style: none;
        padding: 0;
        margin: 0;
        margin-bottom: ${spacing['spacing-4']};
        margin-top: ${spacing['spacing-4']};

        ${mq.large} {
            margin-bottom: ${spacing['spacing-5']};
            margin-top: ${spacing['spacing-5']};
        }
    `;
});

const ListItem = styled('li')((props) => {
    const {
        theme: { colors, spacing, transitionTime }
    } = props;

    return css`
        display: inline-block;
        list-style: none;

        svg {
            transition: fill ${transitionTime};

            &:hover {
                fill: ${colors['primary-dark']};
            }
        }

        &:not(:last-child) {
            margin-right: ${spacing['24px']};
        }

        a {
            display: inline-block;
            border-bottom: none;
        }
    `;
});

const HiddenSpan = styled('span')`
    &:not(:focus):not(:active) {
        display: block;
        width: 1px;
        height: 1px;
        margin: -1px;
        padding: 0;
        -webkit-clip-path: inset(100%);
        clip-path: inset(100%);
        clip: rect(0 0 0 0);
        overflow: hidden;
    }
`;

export { StyledIconList, ListItem, HiddenSpan };
